import {
    GET_AZURE_ALERT,
    GET_AZURE_ALERT_FAIL,
    GET_AZURE_ALERT_SUCCESS,
    GET_AZURE_RESOURCE_BY_RESOURCE_ID,
    GET_AZURE_RESOURCE_BY_RESOURCE_ID_SUCCESS,
    GET_AZURE_RESOURCE_BY_RESOURCE_ID_FAIL,
    GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID,
    GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID_FAIL,
    GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    POST_DISABLE_AZURE_ALERTS,
    POST_DISABLE_AZURE_ALERTS_FAIL,
    POST_DISABLE_AZURE_ALERTS_SUCCESS,
    POST_ENABLE_AZURE_ALERTS,
    POST_ENABLE_AZURE_ALERTS_FAIL,
    POST_ENABLE_AZURE_ALERTS_SUCCESS,
    PUT_AZURE_ALERTS,
    PUT_AZURE_ALERTS_FAIL,
    PUT_AZURE_ALERTS_SUCCESS,
    POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING,
    POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS,
    POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING_FAIL,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_FAIL,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS,
    GET_AZURE_DYNAMIC_ALERT,
    GET_AZURE_DYNAMIC_ALERT_FAIL,
    GET_AZURE_DYNAMIC_ALERT_SUCCESS,
    GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC_SUCCESS,
    POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC_FAIL,
} from "./actionTypes"

export const getAzureAlerts = data => ({
    type: GET_AZURE_ALERT,
    payload: data,
})

export const getAzureAlertsSuccess = azure_alerts => ({
    type: GET_AZURE_ALERT_SUCCESS,
    payload: azure_alerts,
})

export const getAzureAlertsFail = error => ({
    type: GET_AZURE_ALERT_FAIL,
    payload: error,
})


export const getAzureResourceByResourceID = data => ({
    type: GET_AZURE_RESOURCE_BY_RESOURCE_ID,
    payload: data
})

export const getAzureResourceByResourceIDSuccess = azure_resource => ({
    type: GET_AZURE_RESOURCE_BY_RESOURCE_ID_SUCCESS,
    payload: azure_resource,
})

export const getAzureResourceByResourceIDFail = error => ({
    type: GET_AZURE_RESOURCE_BY_RESOURCE_ID_FAIL,
    payload: error,
})

export const getDefaultAzureThresholdByMonitoredResourceID = data => ({
    type: GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID,
    payload: data
})

export const getDefaultAzureThresholdByMonitoredResourceIDSuccess = default_threshold_azure_resource => ({
    type: GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    payload: default_threshold_azure_resource,
})

export const getDefaultAzureThresholdByMonitoredResourceIDFail = error => ({
    type: GET_DEFAULT_AZURE_THRESHOLD_BY_RESOURCE_ID_FAIL,
    payload: error,
})


export const getMissingAzureAlertsByResourceID = data => ({
    type: GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getMissingAzureAlertsByResourceIDSuccess = azure_resource_missing_alerts => ({
    type: GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: azure_resource_missing_alerts,
})

export const getMissingAzureAlertsByResourceIDFail = error => ({
    type: GET_AZURE_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error,
})

export const postDisableAzureAlerts = (data) => ({
    type: POST_DISABLE_AZURE_ALERTS,
    payload: { data }
})

export const postEnableAzureAlerts = (data) => ({
    type: POST_ENABLE_AZURE_ALERTS,
    payload: { data }
})

export const postDisableAzureAlertsSuccess = azure_alerts => ({
    type: POST_DISABLE_AZURE_ALERTS_SUCCESS,
    payload: azure_alerts,
})

export const postEnableAzureAlertsSuccess = azure_alerts => ({
    type: POST_ENABLE_AZURE_ALERTS_SUCCESS,
    payload: azure_alerts,
})

export const postEnableAzureAlertsFail = error => ({
    type: POST_ENABLE_AZURE_ALERTS_FAIL,
    payload: error,
})

export const postDisableAzureAlertsFail = error => ({
    type: POST_DISABLE_AZURE_ALERTS_FAIL,
    payload: error,
})

export const putAzureAlerts = (data) => ({
    type: PUT_AZURE_ALERTS,
    payload: { data }
})

export const putAzureAlertsSuccess = azure_alerts => ({
    type: PUT_AZURE_ALERTS_SUCCESS,
    payload: azure_alerts,
})

export const putAzureAlertsFail = error => ({
    type: PUT_AZURE_ALERTS_FAIL,
    payload: error,
})

export const postSpecificAzureResourceServiceMapping = data => ({
    type: POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING,
    payload: { data }
})

export const postSpecificAzureResourceServiceMappingSuccess = azure_resource => ({
    type: POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS,
    payload: azure_resource,
})

export const postSpecificAzureResourceServiceMappingFail = error => ({
    type: POST_SPECIFIC_AZURE_RESOURCE_SERVICE_MAPPING_FAIL,
    payload: error,
})

export const postSpecificAzureCreateResourceAlerts = (data) => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS,
    payload: { data }
})

export const postSpecificAzureCreateResourceAlertsSuccess = (azure_alerts) => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: azure_alerts
})

export const postSpecificAzureCreateResourceAlertsFail = error => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error,
})

export const getAzureDynamicAlerts = data => ({
    type: GET_AZURE_DYNAMIC_ALERT,
    payload: data,
})

export const getAzureDynamicAlertsSuccess = azure_alerts => ({
    type: GET_AZURE_DYNAMIC_ALERT_SUCCESS,
    payload: azure_alerts,
})

export const getAzureDynamicAlertsFail = error => ({
    type: GET_AZURE_DYNAMIC_ALERT_FAIL,
    payload: error,
})


export const getMissingAzureDynamicAlertsByResourceID = data => ({
    type: GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getMissingAzureDynamicAlertsByResourceIDSuccess = azure_resource_missing_alerts => ({
    type: GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: azure_resource_missing_alerts,
})

export const getMissingAzureDynamicAlertsByResourceIDFail = error => ({
    type: GET_AZURE_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error,
})


export const postSpecificAzureCreateResourceAlertsDynamic = (data) => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC,
    payload: { data }
})

export const postSpecificAzureCreateResourceAlertsDynamicSuccess= (azure_alerts) => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC_SUCCESS,
    payload: azure_alerts
})

export const postSpecificAzureCreateResourceAlertsDynamicFail = error => ({
    type: POST_SPECIFIC_AZURE_CREATE_RESOURCE_ALERTS_DYNAMIC_FAIL,
    payload: error,
})